import styled from "styled-components";
import Img from "../../../../commons/Img";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const Logos = styled(Img)`
  width: 547.56px;
  height: 120.45px;
  margin-top: 30px;
  @media (max-width: 1400px) {
    width: 321.8px;
    height: 69.07px;
  }
`;
